const Header = {
  //#region Sleep
  sleep: function (seconds = 0) {
    /**
     * Função que retorna uma Promise que resolve após um determinado tempo em segundos
     * @param {number} seconds - Tempo em segundos
     * */

    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
  },

  //----------------------------------------------------------------------------

  //#region HandleSearchBar
  handleSearchBar: () => {
    /**
     * Função que gerencia o campo de busca, botões de abrir e fechar a busca
     * e a lista de mensagens do campo de busca
     */

    function animationPlaceholder(input, values = [], time) {
      /**
       * Função que anima o placeholder do campo de busca
       * @param {HTMLElement} input - Campo de busca
       * @param {Array} values - Lista de mensagens
       * @param {number} time - Tempo em milissegundos
       * */

      // cializa o índice
      let index = 0;

      // Altera o placeholder do campo de busca a cada 3 segundos e exibe a mensagem da lista
      setInterval(() => {
        input.placeholder = values[index];
        index = (index + 1) % values.length;
      }, time);
    }

    //--------------------------------------------------------------------------

    // Seleciona o container de busca, botão de abrir e fechar a busca e o campo de busca
    let containerSearchClass;
    let buttonCloseSearchClass;
    let inputSearchClass;

    if (window.innerWidth <= 767) {
      containerSearchClass = 'container-search-mobile';
      buttonCloseSearchClass = 'button-close-search-mobile';
      inputSearchClass = 'input-search-mobile';
    } else {
      containerSearchClass = 'container-search';
      buttonCloseSearchClass = 'button-close-search';
      inputSearchClass = 'input-search-desktop';
    }
    const containerSearch = document.querySelector(`.${containerSearchClass}`);
    const buttonOpen = document.querySelector(`.button-open-search`);
    const buttonClose = document.querySelector(`.${buttonCloseSearchClass}`);
    const inputSearch = document.querySelector(`.${inputSearchClass}`);

    // window.searchSuggestions é uma variável global que armazena as sugestões de busca, ela é inicializada em layout.liquid
    let messages = [...window.searchSuggestions];

    // Altera o placeholder do campo de busca a cada 3 segundos
    animationPlaceholder(inputSearch, messages, 3000);

    // Array de botões
    const buttons = [buttonOpen, buttonClose];

    // Adiciona um evento de click para cada botão e exibe/oculta o campo de busca
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttonOpen.classList.contains(`visible`) && inputSearch.focus();
        containerSearch.classList.toggle(`visible`);
        buttonOpen.classList.toggle(`visible`);
      });
    });
  },

  //----------------------------------------------------------------------------

  //#region HandleCustomMenu
  handleCustomMenu: function () {
    /**
     * Função que gerencia o menu personalizado
     */

    // Seleciona o hamburger, o menu e o container de fundo
    const hamburger = document.querySelector('.hamburger');
    const menu = document.querySelector('.menu');
    const backgroundContainer = document.querySelector('.background-container');
    const containerSearch = document.querySelector('.container-search');
    const buttonClose = document.querySelector(`.button-close-search`);

    if (!hamburger && !menu) return;

    hamburger.addEventListener('click', () => {
      buttonClose && containerSearch && containerSearch.classList.contains(`visible`) && buttonClose.click();
      menu.classList.toggle('open');
      backgroundContainer.classList.toggle('open');
      Californio.sleep(0.5).then(() => {
        menu.classList.toggle('zero-state');
      });
    });

    menu.addEventListener('mouseleave', () => {
      menu.classList.remove('open');
      Californio.sleep(0.5).then(() => {
        menu.classList.add('zero-state');
      });
    });

    backgroundContainer.addEventListener('click', () => {
      menu.classList.toggle('open');
      backgroundContainer.classList.toggle('open');
      Californio.sleep(0.5).then(() => {
        menu.classList.toggle('zero-state');
      });
    });

    backgroundContainer.addEventListener('touchstart', () => {
      menu.classList.remove('open');
      backgroundContainer.classList.remove('open');
      Californio.sleep(0.5).then(() => {
        menu.classList.add('zero-state');
      });
    });
  },

  //----------------------------------------------------------------------------

  //#region EnableBackgroundOpaque
  enableBackgroundOpaque: function () {
    /**
     * Função que habilita o background opaco do menu
     */

    // Se a largura da tela for menor ou igual a 767px, retorna
    if (window.innerWidth <= 767) return;

    // Seleciona o menu, os itens do menu e o background opaco
    const menu = document.querySelector('.header .menu');
    const menuItens = Array.from(menu.querySelectorAll('.menu-item'));
    const backgroundOpaque = menu.querySelector('.background-opaque');

    // Adiciona um evento de mouseenter e mouseleave para cada item do menu
    menuItens.forEach((menu) => {
      // Se o item do menu não possuir submenu, retorna
      if (!menu.classList.contains('has-submenu')) return;

      // Quando o mouse entra no item do menu, exibe o background opaco
      menu.addEventListener('mouseenter', () => {
        backgroundOpaque.classList.add('visible');
      });

      // Quando o mouse sai do item do menu, oculta o background opaco
      menu.addEventListener('mouseleave', () => {
        backgroundOpaque.classList.remove('visible');
      });
    });
  },

  //----------------------------------------------------------------------------

  //#region Init
  init: function () {
    /**
     * Função que inicializa as funções da página
     */
    const _this = this;

    // _this.enableBackgroundOpaque();
    _this.handleSearchBar();
    // _this.handleCustomMenu();
  },
};

export default Header;
